<dx-popup [width]="1250" [height]="740" [showTitle]="false" [(visible)]="bidCompanySearchVisible" [dragEnabled]="false"
    [closeOnOutsideClick]="false">
    <div *dxTemplate="let data of 'content'">
        <h5 class="ap-green">Bid Companies</h5>
        <dx-scroll-view>
            <div class="row">
                <div class="col-4">
                    <div class="form-group">
                        <label for="bidCompanySearch">Search Bid Companies:</label>
                        <dx-text-box id="bidCompanySearch" [(value)]="companyName"></dx-text-box>
                        <label style="color:red" *ngIf="showCompanyErrorMsg">
                            Please enter atleast three characters before
                            searching
                        </label>
                    </div>
                </div>
                <div class="col-1 mt-4">
                    <dx-button text="Search" type="default" [useSubmitBehavior]="false" (onClick)="searchCompanies()">
                    </dx-button>
                </div>
            </div>
            <div class="row">
                <div class="col-5">
                    <dx-data-grid #CompanyGrid id="CompanyGrid" [dataSource]="companyList" keyExpr="companyId"
                        class="companyGridHeight" [selectedRowKeys]="[]" [allowColumnReordering]="true"
                        [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [columnAutoWidth]="true"
                        [rowAlternationEnabled]="true" [columnHidingEnabled]="false" [allowColumnResizing]="true"
                        (onSelectionChanged)="companiesSelectionChangedHandler($event)">

                        <dxo-filter-panel [visible]="false"></dxo-filter-panel>
                        <dxo-filter-row [visible]="true" [applyFilter]="currentFilter"></dxo-filter-row>
                        <dxo-selection mode="single"></dxo-selection>
                        <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
                        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
                        <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
                            [showInfo]="true" [showNavigationButtons]="false">
                        </dxo-pager>

                        <dxi-column dataField="companyName" [width]="300" dataType="string" caption="Company">

                        </dxi-column>
                    </dx-data-grid>
                </div>
                <div class="col-2 addDeletePadding">
                    <div class="">
                        <div class="row d-flex justify-content-center">
                            <dx-button text="Add ->" type="default" [disabled]="disableAddBtn"
                                [useSubmitBehavior]="false" (onClick)="addBidCompany()"></dx-button>
                        </div>
                        <div class="row d-flex justify-content-center mt-3">
                            <dx-button text="Delete >-" type="default" [disabled]="disableDeleteBtn"
                                [useSubmitBehavior]="false" (onClick)="removeBidCompany()"></dx-button>
                        </div>
                    </div>
                </div>
                <div class="col-5">
                    <dx-data-grid #BidCompanyGrid id="BidCompanyGrid" [dataSource]="bidCompanies" keyExpr="companyId"
                        class="bidCompanyGridHeight" [selectedRowKeys]="[]" [allowColumnReordering]="true"
                        [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [columnAutoWidth]="true"
                        [rowAlternationEnabled]="true" [columnHidingEnabled]="false" [allowColumnResizing]="true"
                        (onSelectionChanged)="bidCompanyChangedHandler($event)">

                        <dxo-filter-panel [visible]="false"></dxo-filter-panel>
                        <dxo-selection mode="single"></dxo-selection>
                        <dxo-filter-row [visible]="true" [applyFilter]="currentFilter"></dxo-filter-row>
                        <dxi-column dataField="companyName" [width]="300" dataType="string" caption="Bid Company">

                        </dxi-column>
                    </dx-data-grid>

                </div>
            </div>
            <div class="row">
                <div class="col-md-12 text-center">
                    <dx-button icon="save" [useSubmitBehavior]="false" text="Save"
                        class="ap-green-btn ap-icon mr-1 mt-1 ml-2 px-5" (onClick)="save()">
                    </dx-button>
                    <dx-button [useSubmitBehavior]="false" icon="close" text="Close" class="ap-discard-button mr-1 mt-1 ml-2 px-5"
                        (onClick)="close()">
                    </dx-button>
                </div>
            </div>
        </dx-scroll-view>
    </div>
</dx-popup>

<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
  [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>
